import styled from 'styled-components'
import { breakpoints, colors, fontSizes, fontWeights } from '@/styles'
import { Label, Row } from '@/components/form'
import Panel from '@/components/panel'

export const ContentWrapper = styled.div`
  max-width: 660px;
  width: 100%;
  margin: 40px auto;
  text-align: center;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    margin: 40px 16px;
  }
`

export const StyledPanel = styled(Panel)`
  text-align: left;
  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    margin: 0px;
  }
`

export const AreaTitle = styled.h3`
  height: 35px;
  color: ${colors.darkGrey};
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.bold};
  line-height: 35px;
  text-align: center;
  margin-bottom: ${props => props.bottom || 24}px;
`

export const StyledRow = styled(Row)`
  justify-content: space-between;
  align-items: center;
  margin-left: 0;
  margin-right: 0;
  border-top: ${props => (props.borderTop ? 1 : 0)}px solid ${colors.grey};
`

export const StyledLabel = styled(Label)`
  flex: 1;
  margin-right: 20px;

  ${props =>
    props.bold &&
    `
      font-weight: ${fontWeights.medium};
  `}
`

export const StyledValue = styled(Label)`
  font-weight: ${fontWeights.medium};
  flex: 1;
  text-align: right;
`

export const FeeInfoWrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-left: 5px;
    cursor: pointer;
  }
`

export const InfoTextWrapper = styled.div`
  border-radius: 10px;
  background-color: ${props => (props.complete ? '#e3eeec' : '#faf2da')};
  padding: 20px 35px;
  margin: 35px 0;

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    padding: 20px 25px;
  }
`

export const InfoText = styled.p`
  font-size: 14px;
  letter-spacing: -0.2px;
  line-height: 19px;
  text-align: center;
  margin: 0;

  strong {
    font-weight: ${fontWeights.medium};
  }
`

export const AutoPaymentsWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 16px;
  margin-bottom: 42px !important;
  background: ${colors.blue96};
  border: 1px solid ${colors.blue88};
  border-radius: 6px;
  @media screen and (max-width: ${breakpoints.phoneMax}) {
    flex-direction: column-reverse;
  }
`

export const AutomaticPaymentsTitle = styled.h2`
  font-size: 14px;
  line-height: 20px;
  font-weight: ${fontWeights.medium};
  color: ${colors.blue16};
  margin: 0 0 0 14px;
  margin-bottom: ${props => props.bottom || 0}px;
  margin-top: ${props => props.top || 0}px;
  text-align: ${props => (props.center ? 'center' : 'left')};

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    text-align: center;
  }
`
